import { r as reactDom } from './common/index-ad7768a3.js';
import './common/_commonjsHelpers-913f9c4a.js';
import './common/index-68197ba1.js';



var render = reactDom.render;
export { render };
